// react
import React from 'react';

// material ui
import { Box, Typography } from '@mui/material';

interface DetailInfoFieldProps {
  label: string;
  children: React.ReactNode;
}

/**
 * A labelled info field used inside DetailHeaderCard.
 * Renders an overline label above arbitrary content.
 */
const DetailInfoField = ({ label, children }: DetailInfoFieldProps) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography variant="overline" color="text.secondary">
        {label}
      </Typography>
      {children}
    </Box>
  );
};

export default DetailInfoField;
